import clsx from 'clsx';
import { type ReactNode, cloneElement, useContext } from 'react';
import { type Style, mergeStyle } from './table-header.module.css';
import { TableContext } from '../table/table.component';

interface Props { 
  autoHide?: boolean;
  children?: ReactNode[];
  style?: Style;
}

export function TableHeader(props: Props) {

  const {
    autoHide = false,
    children,
    style: customStyle
  } = props;

  const style = mergeStyle(customStyle);
  const { hiddenHeader } = useContext(TableContext);

  return (
    <thead>
      <tr className={style.container}>
        {
          children?.map((child: any, index) => {
            if (child) {
              return (
                <th 
                  key={index} 
                  className={clsx(style.tab, hiddenHeader && autoHide && style.hiddenHeader)}>
                  {cloneElement(child, { className: style.cellContent })}
                </th>
              );
            }
          })
        }
      </tr>
    </thead>
  );
}
